import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { scrollVariantsLeft } from '../../../constants/TextAnimation';

const NewsLetter = () => {


  const [formData, setFormData] = useState({ email: "" });

  const [error, setError] = useState("");


  const handleEmail = (e) => {
    const { name, value } = e.target;
    const format = value.replace(/[^a-zA-Z0-9@.]/g, "");

    setFormData({ ...formData, [name]: format });

    const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(format);
    setError(isValid ? "" : "Invalid email");
  };
  return (
    <>
      <section>
        <motion.div
          variants={scrollVariantsLeft}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          className="container pb-10 px-4 sm:px-6 lg:px-8 md:pb-20"
        >
          <div className="relative rounded-xl p-5 sm:py-16 before:absolute before:top-0 before:start-[-2rem] overflow-hidden  before:bg-[url('/images/solutions/gril.svg')] before:bg-no-repeat before:bg-top before:bg-contain before:w-2/3 before:h-full before:z-0 bg-neutral-950">
            <div className="max-w-md relative z-10 text-center mx-auto">
              <div className="mb-5">
                <h2 className="text-2xl font-bold md:text-3xl text-white">
                  Unlock Your Business Potential with Scan
                </h2>
                <p className="mt-3 text-neutral-400">
                  Get all the latest solutions updates and news.
                </p>
              </div>

              {/* Subscribe */}
              <form className="">
                <div className="flex flex-col items-center gap-2 md:flex-row sm:gap-3">
                  <div className="w-full">
                    <label htmlFor="hero-input" className="sr-only">
                      Search
                    </label>
                    
                    <input
                      name="email"
                      id="hero-input"

                      placeholder="Enter your email"
                      className="py-2.5 sm:py-3 px-4 block w-full focus:ring-1 focus:ring-gold placeholder-gray-500 transition-all duration-200 bg-neutral-900 border border-gold/10 rounded-md focus:outline-none focus:border-gold caret-gold"
                      type="text"
                      onChange={handleEmail}
                      value={formData.email}
                      maxLength={25}
                    />
                    {error && (
                      <p className="text-red-400 text-sm mt-2">{error}</p>
                    )}

                  </div>
                  <Link
                    className="whitespace-nowrap py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent bg-gold hover:bg-opacity-85 text-slate-950 hover:bg-gold focus:outline-hidden focus:bg-gold disabled:opacity-50 disabled:pointer-events-none"
                    to=""
                  >
                    Subscribe
                  </Link>
                </div>
              </form>
              {/* End Subscribe */}
            </div>
          </div>
        </motion.div>
      </section>
    </>
  );
};

export default NewsLetter;
